import React from 'react';

import { observer } from 'mobx-react-lite';

import { TableFooter, parseNumberByPrecision } from '@pascal/pascal-core';
import { roundInfoStore, userCountStore } from '@pascal/pascal-core/shared/core/store';

import { doBetStore } from '../../store/doBetStore';
import { winningAmountStore } from '../../store/winningAmountStore';

const secondNumber = 1;

const FooterWr = observer(() => {
  const { roundId } = roundInfoStore;
  const { betsTotalAmount } = doBetStore;
  const { usersCount } = userCountStore;
  const { lastWinAmount } = winningAmountStore;

  return (
    <TableFooter
      lastWin={lastWinAmount}
      roundId={`${roundId}`}
      usersCount={usersCount}
      totalBet={parseNumberByPrecision(betsTotalAmount, secondNumber)}
    />
  );
});

export default FooterWr;
